var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyBookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.45 2.8998C19.091 2.8998 18.8 3.19084 18.8 3.5498V23.0498C18.8 23.4082 18.5084 23.6998 18.15 23.6998H3.84998C2.77475 23.6998 1.89998 22.8251 1.89998 21.7498C1.89998 20.6745 2.77475 19.7998 3.84998 19.7998H15.55C16.6252 19.7998 17.5 18.9251 17.5 17.8498V2.2498C17.5 1.17458 16.6252 0.299805 15.55 0.299805H2.54998C1.47475 0.299805 0.599976 1.17458 0.599976 2.2498V21.7498C0.599976 23.5419 2.05793 24.9998 3.84998 24.9998H18.15C19.2252 24.9998 20.1 24.1251 20.1 23.0498V3.5498C20.1 3.19084 19.809 2.8998 19.45 2.8998ZM5.79998 1.5998H8.39998V9.78058L7.55957 8.94021C7.30574 8.68635 6.89417 8.68635 6.64034 8.94021L5.79998 9.78058V1.5998ZM1.89998 2.2498C1.89998 1.89141 2.19158 1.5998 2.54998 1.5998H4.49998V11.3498C4.49998 11.6127 4.65833 11.8497 4.90123 11.9503C5.14413 12.0509 5.42367 11.9953 5.60961 11.8094L7.09998 10.319L8.59038 11.8094C8.71474 11.9338 8.88097 11.9998 9.05014 11.9998C9.13387 11.9998 9.21832 11.9836 9.29876 11.9503C9.54162 11.8497 9.69998 11.6127 9.69998 11.3498V1.5998H15.55C15.9084 1.5998 16.2 1.89141 16.2 2.2498V17.8498C16.2 18.2082 15.9084 18.4998 15.55 18.4998H3.84998C3.11901 18.4998 2.4435 18.7425 1.89998 19.1514V2.2498Z",
    fill: "#717171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyBookIcon);
export default __webpack_public_path__ + "static/media/grey-book-icon.1433253170454d6e4cfb6ed08e501dfc.svg";
export { ForwardRef as ReactComponent };